<!--  FORMULARIO MAS INFORMACION -->
<p class="text-form">Solamente los campos marcados con (*) son obligatorios.</p>
<form
  action=""
  autocomplete="off"
  class="form"
  [formGroup]="formStepMoreInformationLto"
>
  <!-- CURP -->
  <div>
    <mat-form-field appearance="fill" class="input-curp">
      <mat-label>CURP</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Curp (XXXX000000(H|M)XXXXX00)"
        formControlName="curp"
        (keydown)="deleteSpaceInit($event)"
      />
      <div *ngIf="hideButton" matSuffix>
        <button
          mat-icon-button
          color="primary"
          aria-label="Example icon button with a home icon"
          (click)="isOpen = !isOpen"
          type="button"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
        >
          <mat-icon>help</mat-icon>
        </button>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="isOpen"
        >
          <p class="example-list">
            Si no recuerdas tu CURP búscalo desde
            <a href="http://www.gob.mx/curp/" target="_blank">aquí.</a>
          </p>
        </ng-template>
      </div>
      <mat-error
        *ngIf="
          formStepMoreInformationLto.controls['curp'].invalid &&
          formStepMoreInformationLto.controls['curp'].touched
        "
      >
        <span
          *ngIf="
            formStepMoreInformationLto.controls['curp'].errors &&
            formStepMoreInformationLto.controls['curp'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error
        *ngIf="formStepMoreInformationLto.controls['curp'].hasError('pattern')"
        >Formato incorrecto. (XXXX000000(H|M)XXXXX00)
      </mat-error>
    </mat-form-field>
  </div>
  <!-- GENERO -->
  <mat-form-field appearance="fill">
    <mat-label>Género</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="gender">
      <mat-option *ngFor="let gender of gender" [value]="gender.code">
        {{ gender.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['gender'].invalid &&
        formStepMoreInformationLto.controls['gender'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['gender'].errors &&
          formStepMoreInformationLto.controls['gender'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- PAIS NACIMIENTO -->
  <mat-form-field appearance="fill">
    <mat-label>País de nacimiento</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      formControlName="countryOfBirthCode"
    >
      <mat-option
        *ngFor="let country of countries"
        [value]="country.code"
        (onSelectionChange)="selectionCountry(country.code, $event)"
      >
        {{ country.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['countryOfBirthCode'].invalid &&
        formStepMoreInformationLto.controls['countryOfBirthCode'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['countryOfBirthCode'].errors &&
          formStepMoreInformationLto.controls['countryOfBirthCode'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- ESTADO NACIMIENTO -->
  <mat-form-field appearance="fill">
    <mat-label>Estado de nacimiento</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      [formControl]="stateCtrl"
      placeholder="Estado"
      #singleSelect
    >
      <mat-option>
        <ngx-mat-select-search
          [formControl]="statesFilterCtrl"
          placeholderLabel="Buscar estado..."
          noEntriesFoundLabel="'Ningún estado con ese nombre'"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngFor="let state of filteredStates | async"
        [value]="state.id"
      >
        {{ state.name }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="stateCtrl.invalid && stateCtrl.touched">
      <span *ngIf="stateCtrl.errors && stateCtrl.errors['required']"
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- ESTADO CIVIL -->
  <mat-form-field appearance="fill">
    <mat-label>Estado civil</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      formControlName="maritalStatus"
    >
      <mat-option
        *ngFor="let maritalStatus of maritalStatusList"
        [value]="maritalStatus.code"
      >
        {{ maritalStatus.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['maritalStatus'].invalid &&
        formStepMoreInformationLto.controls['maritalStatus'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['maritalStatus'].errors &&
          formStepMoreInformationLto.controls['maritalStatus'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- RFC -->
  <mat-form-field appearance="fill">
    <mat-label>RFC</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese su rfc"
      formControlName="rfc"
      (keydown)="isLetterAndNumber($event)"
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['rfc'].invalid &&
        formStepMoreInformationLto.controls['rfc'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['rfc'].errors &&
          formStepMoreInformationLto.controls['rfc'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="formStepMoreInformationLto.controls['rfc'].hasError('pattern')"
      >Debe ingresar 13 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- INE/IFE -->
  <mat-form-field appearance="fill">
    <mat-label>INE/IFE</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese su INE/IFE"
      formControlName="ine"
      (keydown)="isLetterAndNumber($event)"
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['ine'].invalid &&
        formStepMoreInformationLto.controls['ine'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['ine'].errors &&
          formStepMoreInformationLto.controls['ine'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="formStepMoreInformationLto.controls['ine'].hasError('minlength')"
      >Mínimo 13 caracteres.
    </mat-error>
    <mat-error
      *ngIf="formStepMoreInformationLto.controls['ine'].hasError('maxlength')"
      >Máximo 18 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- OCUPACION -->
  <mat-form-field appearance="fill">
    <mat-label>Ocupación</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="occupationId">
      <mat-option
        *ngFor="let activity of activities"
        [value]="activity.id"
        (onSelectionChange)="validInputOtherOccupation($event)"
      >
        {{ activity.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['occupationId'].invalid &&
        formStepMoreInformationLto.controls['occupationId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['occupationId'].errors &&
          formStepMoreInformationLto.controls['occupationId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- OCUPACION(OTRA) -->
  <mat-form-field
    appearance="fill"
    *ngIf="
      formStepMoreInformationLto.get('occupationId')!.value ==
      '46b404ff-8e58-4834-b292-8effce96e94a'
    "
  >
    <mat-label>Otra(especifique)</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese donde trabaja"
      formControlName="otherOccupation"
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['otherOccupation'].invalid &&
        formStepMoreInformationLto.controls['otherOccupation'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['otherOccupation'].errors &&
          formStepMoreInformationLto.controls['otherOccupation'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['otherOccupation'].hasError(
          'maxlength'
        )
      "
      >Máximo 45 caracteres.
    </mat-error>
  </mat-form-field>

  <!-- CODIGO POSTAL -->
  <mat-form-field appearance="fill">
    <mat-label>Código postal</mat-label>
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese código postal"
      formControlName="postalCodeId"
      (blur)="getPreviousPostalCode($event)"
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['postalCodeId'].invalid &&
        formStepMoreInformationLto.controls['postalCodeId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['postalCodeId'].errors &&
          formStepMoreInformationLto.controls['postalCodeId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['postalCodeId'].hasError('pattern')
      "
      >Debe ingresar 5 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- CALLE -->
  <mat-form-field appearance="fill">
    <mat-label>Calle</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese calle"
      formControlName="street"
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['street'].invalid &&
        formStepMoreInformationLto.controls['street'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['street'].errors &&
          formStepMoreInformationLto.controls['street'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['street'].hasError('maxlength')
      "
      >Máximo 50 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- NUM. ext./Mz -->
  <mat-form-field appearance="fill">
    <mat-label>Num. ext./Mz</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese Num. ext./Mz"
      formControlName="externalNumber"
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['externalNumber'].invalid &&
        formStepMoreInformationLto.controls['externalNumber'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['externalNumber'].errors &&
          formStepMoreInformationLto.controls['externalNumber'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['externalNumber'].hasError(
          'maxlength'
        )
      "
      >Máximo 50 caracteres.
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['externalNumber'].hasError(
          'pattern'
        )
      "
      >Debe ingresar solo letras y números.
    </mat-error>
  </mat-form-field>
  <!-- NUM. int./Lt. -->
  <mat-form-field appearance="fill">
    <mat-label>Num. int./Lt.</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese um. int./Lt."
      formControlName="internalNumber"
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['internalNumber'].hasError(
          'maxlength'
        )
      "
      >Máximo 10 caracteres.
    </mat-error>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['internalNumber'].hasError(
          'pattern'
        )
      "
      >Debe ingresar solo letras y números.
    </mat-error>
  </mat-form-field>
  <!-- COLONIA -->
  <mat-form-field appearance="fill">
    <mat-label>Colonia</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="colonyId">
      <mat-option *ngFor="let option of colonies" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['colonyId'].invalid &&
        formStepMoreInformationLto.controls['colonyId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['colonyId'].errors &&
          formStepMoreInformationLto.controls['colonyId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- ESTADO -->
  <mat-form-field appearance="fill">
    <mat-label>Estado</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese estado"
      formControlName="stateId"
      readonly
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['stateId'].invalid &&
        formStepMoreInformationLto.controls['stateId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['stateId'].errors &&
          formStepMoreInformationLto.controls['stateId'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- MUNICIPIO -->
  <mat-form-field appearance="fill">
    <mat-label>Municipio</mat-label>
    <input
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese municipio"
      formControlName="municipalityId"
      readonly=""
    />
    <mat-error
      *ngIf="
        formStepMoreInformationLto.controls['municipalityId'].invalid &&
        formStepMoreInformationLto.controls['municipalityId'].touched
      "
    >
      <span
        *ngIf="
          formStepMoreInformationLto.controls['municipalityId'].errors &&
          formStepMoreInformationLto.controls['municipalityId'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
</form>
